let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("eufZR"), load("iLgOr"), load("9EW0B"), load("49SvW"), load("fLvJM")]).then(() => parcelRequire('2bMQy'));